"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _allianceAuthorization = require("@/api/allianceAuthorization");
var _DataSource = require("@/views/allianceAuthorization/components/DataSource.js");
var _default = exports.default = {
  data: function data() {
    return {
      optionsData: {}
    };
  },
  created: function created() {
    this.optionsData = _DataSource.optionsData;
  },
  methods: {
    onClose: function onClose() {
      this.onInit();
      this.dialogVisible = false;
    },
    open: function open(val) {
      this.type = val.type;
      this.PlatformName = val.platformCode;
      this.form.platformCode = val.platformCode;
      if (val.type === 'add') {
        this.title = '添加联盟账号';
      } else {
        this.title = '编辑联盟账号';
        this.form = (0, _objectSpread2.default)({}, val.data);
      }
      this.dialogVisible = true;
    },
    resetForm: function resetForm(formName) {
      this.onInit();
      this.$refs[formName].resetFields();
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认提交?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            if (_this.type === 'add') {
              _this.saveAllianceConfig();
            } else {
              _this.updateAllianceConfig();
            }
          }).catch(function () {
            _this.$message({
              type: 'info',
              message: '已取消提交'
            });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    saveAllianceConfig: function () {
      var _saveAllianceConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({}, this.form);
              _context.n = 1;
              return (0, _allianceAuthorization.saveAllianceConfig)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.$message.success('提交成功!');
                this.$emit('refresh');
                this.resetForm('formRef');
                this.dialogVisible = false;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function saveAllianceConfig() {
        return _saveAllianceConfig2.apply(this, arguments);
      }
      return saveAllianceConfig;
    }(),
    updateAllianceConfig: function () {
      var _updateAllianceConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.form);
              _context2.n = 1;
              return (0, _allianceAuthorization.updateAllianceConfig)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$message.success('修改成功!');
                this.$emit('refresh');
                this.resetForm('formRef');
                this.dialogVisible = false;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function updateAllianceConfig() {
        return _updateAllianceConfig2.apply(this, arguments);
      }
      return updateAllianceConfig;
    }()
  }
};